import React from "react"
import { ICandidatSuiviSMDModel } from "@common-models/*"
import { CONST_CANDIDAT_DISPONIBILITE_DATE_EXACTE, CONST_MOBILITE_DEPARTEMENTAL, CONST_MOBILITE_PAR_VILLE, CONST_MOBILITE_REGIONAL } from "@common-constants/*"
import MyTooltip from "@common-utils/MyTooltip"

interface Props {
     dms: ICandidatSuiviSMDModel
}

const CandidatSuiviDmsBadges = ({ dms }: Props) => {
     const renderMobiliteTooltip = () => {
          const isRegional = dms.mobilite === CONST_MOBILITE_REGIONAL
          const isDepartemental = dms.mobilite === CONST_MOBILITE_DEPARTEMENTAL
          const isVille = dms.mobilite === CONST_MOBILITE_PAR_VILLE

          if (!isRegional && !isDepartemental && !isVille) return dms.mobiliteLabel

          return (
               <div className="text-start">
                    <div className="fw-bold mb-2 border-bottom pb-1">{dms.mobiliteLabel}</div>
                    <ul className="m-0 p-0 ps-3 text-start" style={{ listStyleType: "circle" }}>
                         {isRegional &&
                              dms.candidatSuiviSMDRegions?.map((r, i) => (
                                   <li key={i} className="mb-1">
                                        {r.region?.nom}
                                   </li>
                              ))}
                         {isDepartemental &&
                              dms.candidatSuiviSMDDepartements?.map((d, i) => (
                                   <li key={i} className="mb-1">
                                        {d.departement?.nom} <span className="text-gray-400 fs-9">({d.departement?.numero})</span>
                                   </li>
                              ))}
                         {isVille &&
                              dms.candidatSuiviSMDVilles?.map((v, i) => (
                                   <li key={i} className="mb-1">
                                        {v.ville?.nom}
                                   </li>
                              ))}
                    </ul>
               </div>
          )
     }

     return (
          <div className="d-flex flex-wrap gap-2 mt-2">
               {dms.disponibilite && (
                    <span className="badge badge-light-primary fw-bold">
                         <i className="fas fa-calendar-check text-primary me-1" />
                         {dms.disponibilite === CONST_CANDIDAT_DISPONIBILITE_DATE_EXACTE ? dms.disponibiliteDate?.format("DD MMM YYYY") : dms.disponibiliteLabel}
                    </span>
               )}
               {dms.mobilite && (
                    <MyTooltip title={renderMobiliteTooltip() || ""}>
                         <span className="badge badge-light-info fw-bold cursor-help">
                              <i className="fas fa-globe text-info me-1" />
                              {dms.mobiliteLabel}
                         </span>
                    </MyTooltip>
               )}
               {dms.remunerationSouhaiteMontant && (
                    <span className="badge badge-light-success fw-bold">
                         <i className="fas fa-euro-sign text-success me-1" />
                         {dms.remunerationSouhaiteMontant} € {dms.remunerationSouhaiteFormatLabel} / {dms.remunerationSouhaiteJourOrMensuelOrAnnuelLabel}
                    </span>
               )}
          </div>
     )
}

export default CandidatSuiviDmsBadges
